import React, { useEffect, useState } from "react";
import FormContainer from "../components/FormContainer";
import {
  useLocation,
  useNavigate,
  useParams,
  useSearchParams,
} from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import Skeleton from "react-loading-skeleton";
import Message from "../components/Message";
import { getClinicDetails } from "../actions/clinicActions";
import Map from "../components/Map";
import VisitsOfPatient from "../components/VisitsOfPatient";
import PatientDetails from "../components/PatientDetails";
import PatientDetailsForm from "../components/PatientDetailsForm";
import Meta from "../components/Meta";
import { listTradeLabels } from "../actions/drugActions";
import Help from "../components/Help";
import { FaArrowAltCircleDown, FaHome, FaPlusCircle } from "react-icons/fa";
import { intervalToDuration } from "date-fns";
import VisitSecreataryForm from "../components/VisitSecreataryForm";
import { Button } from "react-bootstrap";
import Loader from "../components/Loader";

const PatientScreen = () => {
  const params = useParams();
  const patientId = params.patientId;

  const [searchParams] = useSearchParams();
  const [clinicId] = useState(searchParams.get("clinicId"));
  const [reqDate] = useState(searchParams.get("reqDate"));

  const [editPatientDetails, setEditPatientDetails] = useState(false);
  const [patientVehicle, setPatientVehicle] = useState();
  const [showSecretaryForm, setShowSecretaryForm] = useState(false);

  const userLogin = useSelector((state) => state.userLogin);
  const { userInfo } = userLogin;

  const clinicDetails = useSelector((state) => state.clinicDetails);
  const { norequest, loading, clinic, error } = clinicDetails;

  const patientDetails = useSelector((state) => state.patientDetails);
  const { patient } = patientDetails;

  const tradeLabelsStore = useSelector((state) => state.tradeLabelsStore);
  const { noRequest } = tradeLabelsStore;

  const userPermission = clinic?.members?.find(
    (m) => m.memberId.toString() === userInfo?._id.toString(),
  )?.permissionId;

  const isNurse = userPermission === "2" ? true : false;
  const isPhysician =
    userPermission === "0" || userPermission === "1" ? true : false;
  const isSecretary = userPermission === "3" ? true : false;

  let currentAge = patientVehicle?.birthdate
    ? intervalToDuration({
        start: new Date(patientVehicle.birthdate),
        end: new Date(),
      })
    : {
        days: 0,
        hours: 0,
        minutes: 0,
        months: 0,
        seconds: 0,
        years: 0,
      };

  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();

  if (!localStorage.tradeLabels && noRequest) {
    dispatch(listTradeLabels());
  }

  let tradeLabels =
    localStorage.tradeLabels && JSON.parse(localStorage.tradeLabels);

  useEffect(() => {
    if (!userInfo) {
      navigate(
        `/login-screen?returnFrom=${location.pathname}&clinicId=${clinicId}`,
      );
    } else {
      if (!error) {
        if (norequest || !clinic || clinic._id !== clinicId) {
          dispatch(getClinicDetails(clinicId));
        }
      }
    }
  }, [clinicId, norequest, clinic, userInfo]);

  return (
    <FormContainer>
      <Meta
        title={
          patient && patient.firstName
            ? `${patient.firstName} ${patient.fourthName}`
            : `Patient Screen | ClinicEasy`
        }
      />

      <Map
        titles={[
          {
            idx: "1",
            label: (
              <>
                <FaHome /> Clinic List Screen
              </>
            ),
            path: `/`,
            active: false,
          },
          {
            idx: "3",
            label: !clinic ? "..." : `${clinic.clinicName}`,
            path: `/clinic-screen/${clinic?._id}`,
            active: false,
          },
          {
            idx: "4",
            label: `Patients`,
            path: !clinic
              ? `...`
              : `/patient-list-screen/${clinic?.clinicOwnerId}?clinicId=${clinicId}`,
            active: false,
          },

          {
            idx: "5",
            label: !patientVehicle
              ? `...`
              : `${patientVehicle.firstName} ${patientVehicle.secondName} ${patientVehicle.thirdName} ${patientVehicle.fourthName} `,
            path: ``,
            active: true,
          },
          {
            idx: "6",
            label: patientId.slice(-6),
            path: ``,
            active: true,
          },
        ]}
      />

      {loading && (
        <>
          <Skeleton height="50px" className="mb-5" />
        </>
      )}

      {error && (
        <Message
          children={`Get Clinic Details Err: ${error}`}
          variant={`danger`}
        />
      )}
      <>
        {!error && (
          <>
            {!editPatientDetails ? (
              <PatientDetails
                patientId={patientId}
                setEditPatientDetails={setEditPatientDetails}
                isPhysician={isPhysician}
                patientVehicle={patientVehicle}
                setPatientVehicle={setPatientVehicle}
                currentAge={currentAge}
              />
            ) : (
              <PatientDetailsForm
                patientId={patientId}
                setEditPatientDetails={setEditPatientDetails}
                isPhysician={isPhysician}
                patientVehicle={patientVehicle}
                setPatientVehicle={setPatientVehicle}
                currentAge={currentAge}
              />
            )}
            <VisitsOfPatient
              patientId={patientId}
              clinicId={clinicId}
              tradeLabels={tradeLabels}
              patientVehicle={patientVehicle}
              isPhysician={isPhysician}
              currentAge={currentAge}
              isNurse={isNurse}
              isSecretary={isSecretary}
              setShowSecretaryForm={setShowSecretaryForm}
            />
          </>
        )}
      </>
      {isSecretary && (
        <Button
          className="w-100 p-2 my-2"
          variant="info"
          onClick={() => setShowSecretaryForm(!showSecretaryForm)}
        >
          <FaArrowAltCircleDown /> أضف زيارة جديدة
        </Button>
      )}

      {showSecretaryForm && (
        <VisitSecreataryForm
          reqDate={reqDate}
          clinicId={clinicId}
          clinicOwnerId={clinic.clinicOwnerId}
          patientId={patientId}
        />
      )}

      <Help />
    </FormContainer>
  );
};

export default PatientScreen;
